/**
 * APP-172: the unread badge is `me.unreadTotal`, a snapshot of `GET /chat/me`. A snapshot that
 * left before a read was applied locally counts that read as unread and must not overwrite the
 * badge, and an older response must not overwrite a newer one. Each request takes a token; a read
 * marks every token issued so far as stale.
 */
export interface MeSyncGate {
  /** Token for a `/chat/me` request about to be sent. */
  begin: () => number
  /** A read was applied (locally or by the server): responses already in flight are stale. */
  invalidate: () => void
  /** Whether the response for this token may be applied. */
  accept: (token: number) => boolean
}

export const createMeSyncGate = (): MeSyncGate => {
  let issued = 0
  let staleUpTo = 0
  let applied = 0
  return {
    begin: () => ++issued,
    invalidate: () => { staleUpTo = issued },
    accept: (token) => {
      if (token <= staleUpTo || token < applied) return false
      applied = token
      return true
    }
  }
}

/** Debounce for the follow-up `/chat/me` after reads and replies (one request per burst). */
export const ME_SYNC_DEBOUNCE_MS = 400
